import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import HomeSlide from '../../../components/Home/Slides/HomeSlide';
import MilestoneSlide from '../../../components/Home/Slides/MilestoneSlide';
import './BackgroundDisplay.css';
import ToolSlide from '../Slides/ToolSlide';
import TutorDaySlide from '../Slides/TutorDaySlide';
import TaskSlide from '../Slides/TaskSlide';
import {directDeepLink, GET, makeApiCal, SOURCE_HOME} from '../../../util';
import LeaderboardSlide from "../Slides/LeaderboardSlide";
import PickHourlySlide from "../Slides/PickHourlySlide";
import {cosmosTrackService} from "../../../../../cosmosTracking/cosmosTrackService";
import {view_overview, view_year_end_review} from "../../../../../cosmosTracking/cosmosEvents";
import StarOfTheYearSlide from "../Slides/StarOfTheYearSlide";
import leftarrow from '../../../../../assets/images/leftarrow.png';
import rightarrow from '../../../../../assets/images/rightarrow.png';
import TaskCardMini from '../../OverviewInt/task-card-mini/taskCardMini';
import TasksInt from '../../TasksInt';
import CompleteTaskWin from '../completeTaskWin/CompleteTaskWin';
function BackgroundDisplay() {
	const sliderRef = useRef(null);
	const [background, setBackground] = useState(0);
	const [err, catchError] = useState(false);
	const [apiData, setApiData] = useState();
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const action = {
			method: GET,
			route: 'v1/campaign/homeCard',
			storeData: setApiData,
			catchError: catchError,
		};
		makeApiCal(action);
	}, []);

	useEffect(() => {
		if (apiData) {
			let userData = {
				...apiData.campaignOrg,
			};
			localStorage.setItem('saleData', JSON.stringify(userData));
			setIsLoading(false);
		}
		else if (err) {
			setIsLoading(false);
		}
	}, [apiData]);

	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		autoplay: false,
		autoplaySpeed: 5000,
		appendDots: (dots) => <ul>{dots}</ul>,
		customPaging: (i) => (
			<div className="slick-indicator"></div>
		),
	};
	return (
		<>
			<div className="homeDisplay">
				<div className="homeDisplaySlider">
					<Slider {...settings} ref={sliderRef}>
						{apiData?.homeCard && (
							<HomeSlide data={apiData?.homeCard} />
						)}
						{/* {apiData?.statCardWeb? <StarOfTheYearSlide data={apiData?.homeCard}></StarOfTheYearSlide> : null} */}
						{apiData?.rankingsPage && (
							<LeaderboardSlide data={
								apiData?.rankingsPage.teamRankings?.slice(0, 3)}
							  	deepLink={apiData?.homeCard?.deeplink}/>
						)}
						{apiData?.statCardWeb
							? <CompleteTaskWin cards={apiData?.statCardWeb} dataRedirection={apiData?.statCard}/>
							: null
						}
						{/* <TasksInt data={apiData?.statCardWeb} /> */}
						{(apiData?.peakDayCard || false )&& (
							<MilestoneSlide data={apiData?.peakDayCard}/>
						)}
						{/* {apiData?.peakHourCard &&(
							<PickHourlySlide hourData={apiData?.peakHourCard}/>
						)} */}
						{apiData?.tutorOfTheDayCard  && (
							<TutorDaySlide
								data={apiData?.tutorOfTheDayCard}
								rewardText={apiData?.awardsCard?.subText}/>
						)}
						{apiData?.peakHourCard  && <TaskSlide data={apiData?.peakHourCard}/>}
						{apiData?.toolsCard && <ToolSlide data={apiData?.toolsCard}/>}
					</Slider>
				</div>
				<div className="homeDisplayAction">
					<img className="SliderButton left" onClick={() => sliderRef.current.slickPrev()} src={leftarrow} width={80} alt="carouselLeft" />
					<img className="SliderButton right" onClick={() => sliderRef.current.slickNext()} src={rightarrow} width={80} alt="carouselRight"/>
				</div>
			</div>
		</>
	);
}

export default BackgroundDisplay;
